<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

        <div style="width: 1200px; margin: auto;     padding-bottom: 10%; overflow: hidden; position: relative;">
            <userLeft :active="12" />
            <div class="box5" style="position: relative;">
                <div style="overflow: hidden; position: relative;height: 60px;">
                    <div class="box61" style="float: left;margin-top: 30px;">我的订单</div>
                    <div style="position: absolute; top: 20px; right: 10px;">
                        <a-input-search placeholder="输入订单编号/商品货号/名称查询 " enter-button="查询" size="large" style="width: 400px;" @search="onSearch" v-model="search" />
                    </div>
                </div>
                <div class="box7"></div>
                <div style="overflow: hidden; margin-top: 4%;">
                    <div :class="['head_items', order_active_index == index ? 'active' : '']" @click="chang_order_state(index)" style="position: relative;" v-for="(item, index) in top_navs">
                        <span
                            >{{ item.txt }}
                            <div v-if="order_active_index == index" style="width: 100%;height: 2px; background: #2B9A34; bottom: 0; left: 0; margin-top: 20px;"></div>
                        </span>
                    </div>
                    <a-select default-value="全部订单" style="width: 100px; float: right;" @change="dindan_handleChange">
                        <a-select-option value="全部订单">
                            全部订单
                        </a-select-option>
                        <a-select-option value="可开票订单">
                            可开票订单
                        </a-select-option>
                    </a-select>
                </div>

                <div v-if="kaipiao_show == 0">
                    <div class="head_items2" style="line-height: 40px;">
                        <div style="width: 33.33%; float: left; height: 100%;cursor: pointer;">
                            订单详情
                        </div>
                        <div style="width: 33.33%; float: left; height: 100%;">
                            <a-row>
                                <a-col :span="6">
                                    单价
                                </a-col>
                                <a-col :span="6">
                                    运费
                                </a-col>
                                <a-col :span="6">
                                    付款金额
                                </a-col>
                                <a-col :span="6">
                                    收货人
                                </a-col>
                            </a-row>
                        </div>
                        <div style="width: 33.33%; float: right; text-align: right; height: 100%;">
                            <a-row>
                                <a-col :span="12">
                                    状态
                                </a-col>
                                <a-col :span="12" style="width: 30%;">
                                    操作
                                </a-col>
                            </a-row>
                        </div>
                    </div>

                    <div v-for="(item, index) in order_list" style="overflow: hidden;margin-top: 20px;">
                        <div v-if="top_navs[order_active_index].status == 'COMPLETED'" style="width: 5%;height: 100%;overflow: hidden; float: left;margin-top: 60px;">
                            <a-checkbox @change="item_kaipiao(index)"></a-checkbox>
                        </div>

                        <div :class="['order_box', top_navs[order_active_index].status == 'COMPLETED' ? 'left_order_active' : '']">
                            <div style="width: 96%; margin: auto; border-bottom: 1px solid #EDE9E9; overflow: hidden; padding: 2% 0;">
                                <div class="order_item_title">{{ item.storeName }} 订单编号：{{ item.orderSn }}</div>
                                <div class="order_item_time">下单时间：{{ item.payAt }}</div>
                            </div>

                            <div style="width: 96%; margin: auto; overflow: hidden;">
                                <div style="width: 50%;float: left; overflow: hidden;">
                                    <div class="goods_left_item" v-for="(_item, index) in item.ordersItemList">
                                        <div class="order_item_title">{{ _item.brandName }}</div>
                                        <div class="order_item_title" style="margin-left: 60px;">包装: {{ _item.packaging }}</div>
                                        <div class="order_item_title" style="margin-left: 60px;">x {{ _item.quantity }}</div>
                                        <div class="order_item_title" style="margin-left: 50px;color: #F24145;">￥{{ _item.price / 100 }}</div>
                                        <div class="order_item_title" style="margin-left: 30px;color: #F24145;">￥{{ _item.price / 100 }}</div>
                                    </div>
                                </div>

                                <div style="float: left; overflow: hidden; width: 50%; margin-top: 10px;">
                                    <div class="order_item_title" style="margin-left: 20px; ">
                                        <div style="color: #F24145;">￥{{ item.productAmount / 100 }}</div>
                                        <div style="margin-top: 10px;">{{ item.freight }}</div>
                                        <div style="margin-top: 10px;">{{ item.paymentMethodName }}</div>
                                    </div>
                                    <div class="order_item_title" style="margin-left: 20px;">
                                        <div style="">{{ item.receiverBean.consignee }}</div>
                                        <div style="margin-top: 10px;">{{ item.receiverBean.phone }}</div>
                                    </div>

                                    <div style="overflow: hidden; float: right;">
                                        <div class="order_item_title" style="margin-right: 40px;" v-if="item.orderStatus == 'PENDING_PAYMENT'">
                                            待付款
                                        </div>
                                        <div class="order_item_title" style="margin-right: 40px;" v-if="item.orderStatus == 'PENDING_SHIPMENT'">待发货</div>
                                        <div class="order_item_title" style="margin-right: 40px;" v-if="item.orderStatus == 'SHIPPED'">已发货</div>
                                        <div class="order_item_title" style="margin-right: 40px;" v-if="item.orderStatus == 'RECEIVED'">已收货</div>
                                        <div class="order_item_title" style="margin-right: 40px;" v-if="item.orderStatus == 'OFFLINE_PAID'">
                                            离线付款
                                        </div>
                                        <div class="order_item_title" style="margin-right: 40px;" v-if="item.orderStatus == 'COMPLETED'">已完成</div>
                                        <div class="order_item_title" style="margin-right: 40px;" v-if="item.orderStatus == 'CANCELED'">已取消</div>
                                        <div class="order_item_title" style="margin-right: 40px;" v-if="item.orderStatus == 'PENDING_REFUND'">
                                            待退款
                                        </div>
                                        <div class="order_item_title" style="margin-right: 40px;" v-if="item.orderStatus == 'REFUND'">退款</div>
                                        <div class="order_item_title" style="margin-right: 40px;">
                                            <div class="querenshouh" v-if="item.orderStatus == 'PENDING_PAYMENT'" @click="dindancaozuo(item)">
                                                立即支付
                                            </div>
                                            <div class="querenshouh" v-if="item.orderStatus == 'SHIPPED'" @click="dindancaozuo(item)">确认收货</div>
                                            <div class="order_item_title">
                                                <div style="margin-top: 10px;cursor: pointer;" @click="to_order_details(item)">订单详情</div>
                                                <div style="margin-top: 10px;" v-if="item.orderStatus == 'RECEIVED'">
                                                    <router-link :to="`/refund?uuid=${item.uuid}`" style="color: #333;">退款/退换货</router-link>
                                                </div>
                                                <div style="margin-top: 10px;cursor: pointer;" v-if="item.orderStatus == 'COMPLETED'" @click="dindan_kaipiao(item)">申请开票</div>
                                                <div style="margin-top: 10px;cursor: pointer;" v-if="item.orderStatus == 'COMPLETED'" @click="dindan_shouhuo(item)">订单售后</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div style="width: 100%; margin: 5% auto; overflow: hidden;" v-if="top_navs[order_active_index].status == 'COMPLETED' && order_list.length > 0">
          <div style="overflow: hidden; float: left;">
            <a-checkbox @change="kaipiao_quanxuan(1)" style="float: left;">本页全选</a-checkbox>
            <a-checkbox @change="kaipiao_quanxuan(0)" style="float: left; margin-left: 20px;">本页反选</a-checkbox>
          </div>
          <div @click="_kaipiao_xiayibu" class="kaipiao_xiayibu">下一步</div>
        </div> -->

                    <div v-if="order_list.length == 0" style="margin-top: 40px; text-align: center;">没有记录~</div>
                </div>

                <div v-if="kaipiao_show == 1">
                    <div style="width: 100%;height: 1px;border: 1px dashed #EEEEEE; margin-top: 4%;"></div>
                    <div style="overflow: hidden;">
                        <div class="box6" style=" margin-top: 4%; overflow: hidden;">发票信息</div>
                        <div style="overflow: hidden; margin-top: 4%;">
                            <div @click="_invoice_information_index(0)" :class="['zengzhishui', invoice_information_index == 0 ? 'fapiao_actiive' : '']">增值税普通发票</div>
                            <div @click="_invoice_information_index(1)" :class="['zengzhishui', invoice_information_index == 1 ? 'fapiao_actiive' : '']" style="margin-left: 4%;">增值税专项发票</div>
                        </div>
                        <div v-if="invoice_information_index == 0 && my_fapiao.length > 0" style="width: 100%;height: 60px;background: #F4F4F4; margin-top: 4%;padding: 0 2%;">
                            <div class="fapiaotaitou">
                                发票抬头：{{ my_fapiao[invoice_information_index].title }} <span style="margin-left: 40%;">统一社会信用代码：{{ my_fapiao[invoice_information_index].unifiedSocialCreditCode }}</span>
                            </div>
                        </div>

                        <div v-if="invoice_information_index == 1 && my_fapiao.length > 0" style="width: 100%; border: 1px solid #EEEEEE;margin-top: 20px; padding-bottom: 20px;">
                            <div style="overflow: hidden; margin-top: 20px; margin-left: 20px;">
                                <div style="width: 50%;float: left;" class="zengzhishui_txt">增值税专用发票</div>
                                <div style="width: 50%;float: left;"></div>
                            </div>
                            <div style="overflow: hidden; margin-top: 20px; margin-left: 20px;">
                                <div style="width: 50%;float: left;" class="zengzhishui_txt">公司名称：{{ my_fapiao[invoice_information_index].title }}</div>
                                <div style="width: 50%;float: left;">统一社会信用代码：{{ my_fapiao[invoice_information_index].unifiedSocialCreditCode }}</div>
                            </div>
                            <div style="overflow: hidden; margin-top: 20px; margin-left: 20px;">
                                <div style="width: 50%;float: left;" class="zengzhishui_txt">注册地址：{{ my_fapiao[invoice_information_index].registerAddress }}</div>
                                <div style="width: 50%;float: left;">注册电话：{{ my_fapiao[invoice_information_index].registerTel }}</div>
                            </div>
                            <div style="overflow: hidden; margin-top: 20px; margin-left: 20px;">
                                <div style="width: 50%;float: left;" class="zengzhishui_txt">开户银行：{{ my_fapiao[invoice_information_index].bankName }}</div>
                                <div style="width: 50%;float: left;">银行账号：{{ my_fapiao[invoice_information_index].bankAccount }}</div>
                            </div>
                            <div style="overflow: hidden; margin-top: 20px; margin-left: 20px;">
                                <div style="width: 20%;float: left; margin-top: 20px;" class="zengzhishui_txt">证书扫描件</div>
                                <div style="width: 50%;float: left;">
                                    <img v-if="item" :src="'/api/file/preview/' + item" :key="index" v-for="(item, index) in my_fapiao[invoice_information_index].scanList" style="width: 80px; height: 84px; float: left;margin-left: 10px;" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style="width: 100%;height: 1px;border: 1px dashed #EEEEEE; margin-top: 4%;"></div>
                    <div style="overflow: hidden;">
                        <div class="box6" style=" margin-top: 4%; overflow: hidden;">收票方式</div>
                        <div style="overflow: hidden; margin-top: 4%;">
                            <div @click="_ticket_collection_index(0)" :class="['zengzhishui', ticket_collection_index == 0 ? 'fapiao_actiive' : '']">电子发票</div>
                            <div @click="_ticket_collection_index(1)" :class="['zengzhishui', ticket_collection_index == 1 ? 'fapiao_actiive' : '']" style="margin-left: 4%;">邮寄纸质发票</div>
                        </div>
                        <div style="width: 100%;height: 60px;background: #F4F4F4; margin-top: 4%;padding: 0 2%;">
                            <div class="fapiaotaitou">
                                <a-radio style="float: left; margin-top: 20px;color: #666;"></a-radio>
                                <span>姓名：{{ morenfapiao.name }}</span>
                                <span style="margin-left: 20%;">手机：{{ morenfapiao.mobile }}</span>
                                <span style="margin-left: 20%;">收票地址：{{ morenfapiao.address }}</span>
                                <span style="float: right;" class="moren_box">默认{{ morenfapiao.types == 'PAPER' ? '纸质' : '电子' }}发票</span>
                            </div>
                        </div>

                        <div v-if="fapiao_list_show" style="overflow: hidden; border: 1px solid #CCCCCC; border-bottom: none; border-right: none; width: 100%; margin-top: 20px;">
                            <div>
                                <div style="width: 10%;" class="fapial_list_item"></div>
                                <div style="width: 20%;" class="fapial_list_item">姓名</div>
                                <div style="width: 20%;" class="fapial_list_item">手机</div>
                                <div style="width: 50%;" class="fapial_list_item"></div>
                            </div>

                            <!-- 电子发票 -->
                            <div v-if="ticket_collection_index == 0" v-for="(item, index) in user_invoice_receive.ELECTRONIC">
                                <div style="width: 10%; text-align: center;" class="fapial_list_item">
                                    <a-radio v-model="item.active" @change="dianzifapiao(index, 0)" style="color: #666; float: left; margin-top: 10px; margin-left: 35px;"></a-radio>
                                </div>
                                <div style="width: 20%;" class="fapial_list_item">{{ item.name }}</div>
                                <div style="width: 20%;" class="fapial_list_item">{{ item.mobile }}</div>
                                <div style="width: 50%;" class="fapial_list_item">
                                    <a-row>
                                        <a-col :span="12" v-if="item.defaults">
                                            <div class="table_head_txt moren_box" style="min-width: 104px;margin: 5px auto !important;">默认电子发票</div>
                                        </a-col>
                                        <a-col :span="12" @click="shezhimoren(item)" class="table_head_txt" style="color: #2c9a34; cursor: pointer;" v-else>设为默认电子发票</a-col>
                                        <a-col :span="6" class="table_head_txt" style="color: #2c9a34"><router-link :to="'/add_ticket_collection_method?uuid=' + item.uuid" style="color: #2c9a34;">编辑</router-link></a-col>
                                        <a-col @click="shanchu(item.uuid)" :span="6" class="table_head_txt" style="color: #2c9a34">删除</a-col>
                                    </a-row>
                                </div>
                            </div>

                            <!-- 纸质发票 -->
                            <div v-if="ticket_collection_index == 1" v-for="(item, index) in user_invoice_receive.PAPER">
                                <div style="width: 10%; text-align: center;" class="fapial_list_item">
                                    <a-radio v-model="item.active" @change="dianzifapiao(index, 1)" style="float: left; margin-top: 10px; margin-left: 35px;"></a-radio>
                                </div>
                                <div style="width: 20%;" class="fapial_list_item">{{ item.name }}</div>
                                <div style="width: 20%;" class="fapial_list_item">{{ item.mobile }}</div>
                                <div style="width: 50%;" class="fapial_list_item">
                                    <a-row>
                                        <a-col :span="12" v-if="item.defaults">
                                            <div class="table_head_txt moren_box" style="min-width: 104px;margin: 5px auto !important;">默认纸质发票</div>
                                        </a-col>
                                        <a-col :span="12" @click="shezhimoren(item)" class="table_head_txt" style="color: #2c9a34; cursor: pointer;" v-else>设为默认纸质发票</a-col>
                                        <a-col :span="6" class="table_head_txt" style="color: #2c9a34"><router-link :to="'/add_ticket_collection_method?uuid=' + item.uuid" style="color: #2c9a34;">编辑</router-link></a-col>
                                        <a-col @click="shanchu(item.uuid)" :span="6" class="table_head_txt" style="color: #2c9a34">删除</a-col>
                                    </a-row>
                                </div>
                            </div>
                        </div>

                        <div @click="fapiao_list_show = !fapiao_list_show" class="shouqifapiao" style="overflow: hidden;">
                            <span style="float: left;">{{ fapiao_list_show ? '收起' : '展开' }}电子发票</span>
                            <a-icon style="float: left; margin-top: 3px; margin-left: 10px;" :type="fapiao_list_show ? 'up' : 'down'" />
                        </div>

                        <div style="margin-top: 20px;">
                            <p class="fapiaoxiangqing_txt">发票详情</p>
                            <p class="fapiaoxiangqing_txt1">发票内容：{{ kaipiao_order[0].ordersItemList[0].productName }}</p>
                            <p class="fapiaoxiangqing_txt1">开票方：{{ kaipiao_order[0].storeName }}</p>
                            <p class="fapiaoxiangqing_txt1">
                                发票总金额：<span style="color: #F24145; font-size: 18px;"
                                    >￥
                                    {{ kaipiao_order[0].orderAmount }}
                                </span>
                            </p>
                        </div>

                        <div style="width: 100%; height: 1px; background: #EEEEEE;"></div>

                        <div @click="_tijiaofapiao" class="tijiaofapiao">提交</div>
                    </div>
                </div>

                <div v-if="kaipiao_show == 2">
                    <div style="margin-top: 40px; margin-left: 65px;">
                        <div style="overflow: hidden;">
                            <img src="../assets/wangjimima_zhengque.png" style="width: 44px; height: 44px; float: left;" alt="" />
                            <div class="kaipiaochengon_txt">开票成功</div>
                        </div>
                        <div style="margin-left: 30px; margin-top: 10px;" class="kaipiaochengon_txt1">
                            <div style="margin-top: 40px;">
                                <p>订单编号：{{ fapiao_res.orderId }}</p>
                                <p>收货地址：{{ fapiao_res.name }} {{ fapiao_res.mobile }} {{ fapiao_res.address }}</p>
                            </div>

                            <p style="margin-top: 40px;">
                                您可以 <span style=" margin-left: 20px;"><router-link style="color: #2B9A34;" to="/billing_record">查看已开票记录</router-link> </span> <span style="margin-left: 20px;"><router-link style="color: #2B9A34;" :to="'/invoice_details?uuid=' + fapiao_res.orderId">查看发票详情</router-link></span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div style="position: absolute; bottom: 2%; width: 100%;display: flex;justify-content: center;align-items: center;">
                <a-pagination show-quick-jumper :default-current="1" :total="totalPages * 10" @change="fenye_onChange" />
            </div>
        </div>
        <foot />

        <a-modal centered @cancel="visible_shouhuo = false" :visible="visible_shouhuo" :footer="null" :width="480" :height="240">
            <div class="pop_title">我确认已收到货</div>
            <div style="overflow: hidden; width: 50%; margin: 20px auto;">
                <div class="pop_left_bue" @click="_querenshouhuo" style="cursor: pointer;">确定</div>
                <div
                    class="pop_left_bue"
                    @click="visible_shouhuo = false"
                    style="float: right;
        border: 1px solid #EDE9E9; color: #666; background: #fff;cursor: pointer;"
                >
                    取消
                </div>
            </div>
            <div class="pop_tisp">* 请收到货后，再确认收货! 如果您想申请售后，<span style="color: #2B9A34;cursor: pointer;" @click="dindan_shouhuo(shouhuo_obj)">请点击这里</span></div>
        </a-modal>
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
export default {
    name: 'integral',
    components: {
        userLeft,
        htmlHeader,
        foot
    },
    data() {
        return {
            totalPages: 1, //总页数
            shouhuo_obj: '', //待收货订单数据
            visible_shouhuo: false, //确认收货弹框
            fapiao_list_show: true, //是否显示发票列表
            top_navs: [
                {
                    txt: '全部订单',
                    status: ''
                },
                {
                    txt: '待付款',
                    status: 'PENDING_PAYMENT'
                },
                {
                    txt: '待发货',
                    status: 'PENDING_SHIPMENT'
                },
                {
                    txt: '待收货',
                    status: 'SHIPPED'
                },
                {
                    txt: '已取消',
                    status: 'CANCELED'
                },
                {
                    txt: '已完成',
                    status: 'COMPLETED'
                },
                {
                    txt: '退/换订单',
                    status: 'PENDING_REFUND'
                },
                {
                    txt: '可开票订单',
                    status: 'COMPLETED'
                }
            ], // 顶部切换所有状态
            visible: false, //弹框
            order_active_index: 0, //顶部切换索引
            page: 0, //页码
            search: '', //搜索内容
            order_list: [], //订单列表

            // 发票相关的数据
            kaipiao_show: 0, //视图切换 0 订单列表 1 开票视图 2 开票成功
            invoice_information_index: 0, // 0 增值税普通发票 1 增值税专项发票
            ticket_collection_index: 0, // 0 电子发票 1 邮寄纸质发票
            kaipiao_order: [], //待开票的订单集合
            my_fapiao: [], //我的发票资料 专票和普票
            user_invoice_receive: {
                ELECTRONIC: [], //电子
                PAPER: [] //纸质
            }, //获取我的发票接收方式列表
            morenfapiao: '', //默认发票
            fapiao_res: '' //返回的开票成功的信息
        };
    },
    methods: {
        // 右侧下拉切换订单类型
        dindan_handleChange(e) {
            if (e == '可开票订单') {
                this.order_active_index = 7;
                console.log(this.order_active_index);
                this.get_my_orders();
            } else if (e == '全部订单') {
                this.order_active_index = 0;
                this.get_my_orders();
            }
        },
        // 确认收货
        _querenshouhuo() {
            const that = this;
            that.$confirm({
                title: `确定收货吗?`,
                onOk() {
                    that.api
                        .order_received({
                            id: that.shouhuo_obj.uuid
                        })
                        .then(res => {
                            if (res.ok) {
                                that.$message.success(res.message);
                                that.get_my_orders();
                                that.visible_shouhuo = false;
                            } else {
                                that.$message.error(res.message);
                            }
                        });
                }
            });
        },
        // 订单售后
        dindan_shouhuo(e) {
            this.$router.push('/refund?uuid=' + e.uuid);
        },
        // 单个订单点击申请开票
        dindan_kaipiao(e) {
            this.kaipiao_order[0] = e;
            this.kaipiao_show = 1;
            this.get_user_invoice();
            this.get_user_invoice_receive();
        },
        // 确认提交开票
        _tijiaofapiao() {
            const that = this;
            let obj = {
                orderId: that.kaipiao_order[0].uuid, //订单ID
                userInvoiceId: that.my_fapiao[that.invoice_information_index].uuid, //发票ID
                userInvoiceReceiveId: that.morenfapiao.uuid //收票方式ID
            };
            that.$confirm({
                title: `确定开票吗?`,
                onOk() {
                    that.api.user_order_add_invoice(obj).then(res => {
                        if (res.ok) {
                            that.$message.success(res.message);
                            this.fapiao_res = res.data;
                        } else {
                            that.$message.error(res.message);
                        }
                    });
                }
            });
        },
        // 设置默认
        shezhimoren(e) {
            const that = this;
            let obj = e;
            obj.defaults = true;
            that.$confirm({
                title: `设置为默认吗?`,
                onOk() {
                    that.api.add_user_invoice_receive(obj).then(res => {
                        if (res.ok) {
                            that.$message.success(res.message);
                            that.get_user_invoice_receive();
                        } else {
                            that.$message.error(res.message);
                        }
                    });
                }
            });
        },
        // 删除
        shanchu(e) {
            const that = this;
            that.$confirm({
                title: `确定删除吗?`,
                onOk() {
                    that.api.delete_user_invoice_receive(e).then(res => {
                        if (res.ok) {
                            that.$message.success(res.message);
                            that.get_user_invoice_receive();
                        } else {
                            that.$message.error(res.message);
                        }
                    });
                }
            });
        },
        // 切换单选
        dianzifapiao(e, index) {
            if (index == 0) {
                // 电子切换
                this.user_invoice_receive.ELECTRONIC.forEach((element, _index) => {
                    if (_index == e) {
                        element.active = true;
                    } else {
                        element.active = false;
                    }
                });
            } else if (index == 1) {
                // 纸质切换
                this.user_invoice_receive.PAPER.forEach((element, _index) => {
                    if (_index == e) {
                        element.active = true;
                    } else {
                        element.active = false;
                    }
                });
            }
        },
        // 获取我的发票接收方式列表
        get_user_invoice_receive() {
            this.user_invoice_receive.ELECTRONIC = [];
            this.user_invoice_receive.PAPER = [];
            this.api.get_user_invoice_receive().then(res => {
                if (res.ok) {
                    res.data.forEach(element => {
                        if (element.defaults) {
                            // 存储默认发票
                            this.morenfapiao = element;
                        }
                        element.active = false; //单选标识
                        if (element.types == 'ELECTRONIC') {
                            // 电子发票
                            this.user_invoice_receive.ELECTRONIC.push(element);
                        } else if (element.types == 'PAPER') {
                            // 电子发票
                            this.user_invoice_receive.PAPER.push(element);
                        }
                    });
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 我的发票资料 专票和普票
        get_user_invoice() {
            this.api.get_user_invoice('GENERAL').then(res => {
                if (res.ok) {
                    this.my_fapiao[0] = res.data; //普票
                } else {
                    this.$message.error(res.message);
                }
            });

            this.api.get_user_invoice('DEDICATED').then(res => {
                if (res.ok) {
                    this.my_fapiao[1] = res.data; //专票
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 切换发票方式
        _invoice_information_index(e) {
            this.invoice_information_index = e;
        },
        _ticket_collection_index(e) {
            this.ticket_collection_index = e;
            console.log(this.user_invoice_receive);
        },
        // 选中单个开票订单
        item_kaipiao(index) {
            this.order_list[index].kaipiao_code = !this.order_list[index].kaipiao_code;
        },
        // 选择开票点击下一步
        _kaipiao_xiayibu() {
            /*
                                this.kaipiao_order[0] = e
                  this.kaipiao_show = 1
                  this.get_user_invoice()
                  this.get_user_invoice_receive()
                */
            this.kaipiao_order = [];
            this.order_list.forEach(element => {
                if (element.kaipiao_code) {
                    this.kaipiao_order.push(element);
                }
            });
            this.kaipiao_show = 1;
            this.get_user_invoice();
            this.get_user_invoice_receive();
        },
        // 开票全选
        kaipiao_quanxuan(e) {
            let order_list = this.order_list;
            order_list.forEach(element => {
                // 添加左侧开票多选按钮
                element.kaipiao_code = e == 0 ? false : true;
            });
            this.order_list = order_list;
            console.log(this.order_list);
        },
        // 切换右侧全部订单
        handleChange(e) {
            console.log(e);
        },
        // 去订详情
        to_order_details(e) {
            this.$router.push('/pay_to?uuid=' + e.uuid);
        },
        // 订单操作
        dindancaozuo(e) {
            if (e.orderStatus == 'PENDING_PAYMENT') {
                // 待付款 去付款也
                this.$router.push('/credit_pay?uuid=' + e.uuid);
            }
            if (e.orderStatus == 'SHIPPED') {
                // 待收货
                this.shouhuo_obj = e;
                this.visible_shouhuo = true;
            }
        },
        // 翻页
        fenye_onChange(e) {
            this.page = e - 1;
            this.get_my_orders();
        },
        // 监听搜索
        onSearch(e) {
            this.search = e;
            this.get_my_orders();
        },
        // 订单列表
        get_my_orders() {
            this.api
                .get_my_orders({
                    size: 10,
                    page: this.page,
                    search: this.search,
                    status: this.top_navs[this.order_active_index].status
                })
                .then(res => {
                    if (res.ok) {
                        this.order_list = res.data.content;
                        this.totalPages = res.data.totalPages;
                        this.order_list.forEach(element => {
                            // 添加左侧开票多选按钮
                            element.kaipiao_code = false;
                        });
                        console.log(this.order_list);
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        // 切换订单类型
        chang_order_state(e) {
            this.kaipiao_show = 0;
            this.order_active_index = e;
            this.get_my_orders();
        }
    },
    created() {
        this.get_my_orders();
    }
};
</script>

<style scoped>
.kaipiaochengon_txt1 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}

.kaipiaochengon_txt {
    float: left;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-left: 20px;
    margin-top: 10px;
}

.zengzhishui_txt {
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 17px;
}

.tijiaofapiao {
    float: right;
    margin-top: 20px;
    text-align: center;
    width: 100px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    border: 1px solid #2b9a34;
    cursor: pointer;
}

.fapiaoxiangqing_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 28px;
}

.fapiaoxiangqing_txt1 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 10px;
}

.goods_left_item {
    height: 100px;
    line-height: 100px;
    /* border-bottom: 1px solid #EDE9E9; */
    border-right: 1px solid #ede9e9;
}

.pop_tisp {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    text-align: center;
    margin-top: 20px;
}

.pop_left_bue {
    width: 100px;
    height: 40px;
    background: #2b9a34;
    float: left;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
}

.pop_title {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 20px;
    text-align: center;
}

.querenshouh {
    width: 60px;
    height: 24px;
    border: 1px solid #2b9a34;
    cursor: pointer;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    text-align: center;
    line-height: 24px;
}

.order_item_time {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
    float: right;
}

.order_item_title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    float: left;
}

.order_box {
    width: 100%;
    border: 1px solid #ede9e9;
}

.head_items2 {
    width: 100%;
    padding: 0 2%;
    height: 40px;
    background: #f4f4f4;
    margin-top: 4%;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    text-align: center;
}

.head_items {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    text-align: left;
    width: 11.111%;
    float: left;
    cursor: pointer;
    text-align: center;
    padding: 0 15px;
    margin-top: 5px;
}

.box7 {
    width: 100%;
    height: 1px;
    border-top: 1px solid #e8e6e6;
    margin-top: 2%;
}

.box61 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    /* margin-top: 2%; */
    text-align: left;
}

.box5 {
    min-height: 1023px;
    width: 80%;
    border: 1px solid #ede9e9;
    float: right;
    margin-top: 2%;
    padding: 0 2%;
    min-height: 1023px;
}

.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
}

.box4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}

.active {
    color: #2b9a34;
}

.box6 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    /* margin-top: 2%; */
    text-align: left;
}

.fapiaotaitou {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 60px;
}

.zengzhishui {
    width: 140px;
    height: 40px;
    border: 1px solid #ede9e9;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    text-align: center;
    line-height: 40px;
    float: left;
    cursor: pointer;
}
/* 选择发票方式 */

.fapiao_actiive {
    border-color: #2b9a34;
}
/* 是否显示左边的选择按钮 */

.left_order_active {
    float: right;
    width: 95%;
}
/* 开票下一步按钮 */

.kaipiao_xiayibu {
    width: 100px;
    height: 40px;
    border: 1px solid #2b9a34;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    cursor: pointer;
    float: right;
}
/* 默认发票样式 */

.moren_box {
    background: #f24246;
    color: #fff !important;
    width: 90px;
    height: 26px;
    background: #f24246;
    line-height: 26px !important;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    margin-top: 15px !important;
    text-align: center;
}
/* 发票列表样式 */

.fapial_list_item {
    height: 40px;
    float: left;
    border-right: 1px solid #cccccc;
    border-bottom: 1px solid #cccccc;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
}

.table_head_txt {
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    text-align: center;
    line-height: 43px;
    cursor: pointer;
}

.shouqifapiao {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    cursor: pointer;
    margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dinzhi_order.vue